module.exports = __webpack_public_path__ + "img/AT0000000548014.7d9f4a80.png";